import React, { useState, useEffect } from 'react';
import { Menu, X, Flame, Zap, Target, Heart, Dumbbell, Pill, ChevronDown, Phone, Mail, Instagram } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const TurboCut = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const whatsappNumber = '5521972232170';
  const whatsappMessage = encodeURIComponent('Olá! Quero comprar o TurboCut (Emagrecedor Extra Forte). Pode me passar preço e formas de pagamento?');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMenuOpen(false);
    }
  };

  const menuItems = [
  { label: 'Benefícios', id: 'beneficios' },
  { label: 'Como Usar', id: 'como-usar' },
  { label: 'Composição', id: 'composicao' },
  { label: 'FAQ', id: 'faq' }];


  const benefits = [
  { icon: Flame, title: 'Termogênese Ativada', description: 'Acelera o metabolismo naturalmente' },
  { icon: Zap, title: 'Mais Foco e Disposição', description: 'Energia limpa durante o dia' },
  { icon: Target, title: 'Menos Compulsão', description: 'Controle do apetite' },
  { icon: Heart, title: 'Oxidação de Gordura', description: 'Auxilia na queima de gordura' },
  { icon: Dumbbell, title: 'Energia para Treinar', description: 'Performance nos treinos' },
  { icon: Pill, title: 'Uso Prático', description: 'Cápsulas fáceis de tomar' }];


  const composition = [
  { name: 'Cafeína Anidra', description: 'Estimula metabolismo e energia' },
  { name: 'Extrato de Chá Verde', description: 'Antioxidante e termogênico' },
  { name: 'L-Carnitina Fumarato', description: 'Transporte de ácidos graxos' },
  { name: 'Picolinato de Cromo', description: 'Controle de glicose e apetite' },
  { name: 'Capsaicina', description: 'Aumenta termogênese' },
  { name: 'Piperina', description: 'Melhora absorção de nutrientes' }];


  const testimonials = [
  { text: 'Senti mais disposição nos treinos.', author: 'Cliente Satisfeito' },
  { text: 'Me ajudou muito na dieta.', author: 'Cliente Satisfeito' },
  { text: 'Ótimo custo-benefício.', author: 'Cliente Satisfeito' }];


  const faqs = [
  {
    question: 'Em quanto tempo faz efeito?',
    answer: 'Os efeitos podem variar de pessoa para pessoa. Geralmente, a energia e disposição são notadas nos primeiros dias. Resultados mais significativos dependem de dieta equilibrada e exercícios físicos.'
  },
  {
    question: 'Tem cafeína?',
    answer: 'Sim, TurboCut contém cafeína anidra em sua fórmula, que ajuda a aumentar o metabolismo e fornecer energia. Se você é sensível à cafeína, consulte um profissional de saúde.'
  },
  {
    question: 'Posso tomar à noite?',
    answer: 'Não recomendamos tomar à noite devido à presença de cafeína. O ideal é tomar pela manhã ou antes do treino para aproveitar o pico de energia.'
  },
  {
    question: 'Serve para homens e mulheres?',
    answer: 'Sim! TurboCut foi desenvolvido para auxiliar tanto homens quanto mulheres em seus objetivos de emagrecimento e definição.'
  },
  {
    question: 'Precisa de dieta?',
    answer: 'Para melhores resultados, recomendamos associar o uso do TurboCut a uma alimentação equilibrada e prática regular de exercícios físicos. O suplemento potencializa seus esforços.'
  },
  {
    question: 'Como comprar?',
    answer: 'É super fácil! Clique em qualquer botão verde "COMPRAR NO WHATSAPP" nesta página e você será direcionado para nosso atendimento via WhatsApp, onde passaremos todas as informações sobre preços e formas de pagamento.'
  }];


  return (
    <div className="bg-black text-white">
      {/* Header/Navigation */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-orange-500/10' : 'bg-transparent'}`
      }>
        <nav className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Flame className="w-8 h-8 text-orange-500" />
              <span className="text-2xl font-bold">
                <span className="text-white">Turbo</span>
                <span className="text-orange-500">Cut</span>
              </span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-8">
              {menuItems.map((item) =>
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-300 hover:text-orange-500 transition-colors duration-300 font-medium">

                  {item.label}
                </button>
              )}
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-full font-semibold transition-all duration-300 hover:scale-105 shadow-lg shadow-green-600/30">

                Comprar Agora
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden text-white p-2 hover:bg-orange-500/10 rounded-lg transition-colors duration-300">

              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen &&
          <div className="md:hidden mt-4 py-4 border-t border-gray-800">
              {menuItems.map((item) =>
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="block w-full text-left py-3 text-gray-300 hover:text-orange-500 hover:bg-orange-500/5 transition-all duration-300 px-4 rounded">

                  {item.label}
                </button>
            )}
              <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-4 bg-green-600 hover:bg-green-700 text-white text-center px-6 py-3 rounded-full font-semibold transition-all duration-300">

                Comprar Agora
              </a>
            </div>
          }
        </nav>
      </header>

      {/* Hero Section */}
      <section className="pt-24 pb-16 md:pt-32 md:pb-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-orange-500/5 via-transparent to-transparent"></div>
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-center md:text-left z-10">
              <div className="inline-block mb-4 px-4 py-2 bg-orange-500/10 border border-orange-500/30 rounded-full">
                <span className="text-orange-500 font-semibold text-sm">FÓRMULA POTENTE</span>
              </div>
              
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
                Turbo<span className="text-orange-500">Cut</span>
              </h1>
              
              <p className="text-2xl md:text-3xl text-gray-300 mb-4">
                Emagrecedor Extra Forte
              </p>
              
              <p className="text-lg text-amber-400 mb-8 font-medium">
                Fórmula potente • Alta concentração de ativos
              </p>

              <div className="space-y-3 mb-8">
                <div className="flex items-center gap-3 justify-center md:justify-start">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-300">Aumenta termogênese</span>
                </div>
                <div className="flex items-center gap-3 justify-center md:justify-start">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-300">Reduz apetite e compulsão</span>
                </div>
                <div className="flex items-center gap-3 justify-center md:justify-start">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-300">Energia limpa (sem pico/queda)</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 shadow-xl shadow-green-600/40 flex items-center justify-center gap-2">

                  <Phone className="w-5 h-5" />
                  COMPRAR NO WHATSAPP
                </a>
                <button
                  onClick={() => scrollToSection('composicao')}
                  className="border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-black px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105">

                  VER COMPOSIÇÃO
                </button>
              </div>
            </div>

            <div className="relative z-10 flex justify-center items-center">
              <div className="relative">
                <div className="absolute inset-0 bg-orange-500/20 blur-3xl rounded-full"></div>
                <img
                  src="https://customer-assets.emergentagent.com/job_6ad70d3b-2701-4b7a-a8e4-25dc8649bd9c/artifacts/24n9r3tt_turbocut.jpg"
                  alt="TurboCut - Emagrecedor Extra Forte"
                  className="relative w-full max-w-md mx-auto drop-shadow-2xl animate-float" />

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof */}
      <section className="py-16 bg-gradient-to-b from-transparent to-orange-500/5">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            O Que Dizem Nossos <span className="text-orange-500">Clientes</span>
          </h2>
          <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
            Pessoas reais, resultados reais
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-8">
            {testimonials.map((testimonial, index) =>
            <div
              key={index}
              className="bg-gradient-to-br from-gray-900 to-gray-800 p-6 rounded-2xl border border-amber-500/20 hover:border-orange-500/50 transition-all duration-300 hover:transform hover:scale-105 shadow-lg">

                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) =>
                <div key={i} className="w-5 h-5 text-amber-400">★</div>
                )}
                </div>
                <p className="text-gray-300 mb-4 italic">"{testimonial.text}"</p>
                <p className="text-sm text-gray-500">— {testimonial.author}</p>
              </div>
            )}
          </div>

          <p className="text-center text-xs text-gray-500">
            * Resultados variam de pessoa para pessoa.
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="beneficios" className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            Benefícios do <span className="text-orange-500">TurboCut</span>
          </h2>
          <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
            Fórmula completa para potencializar seus resultados
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div
                  key={index}
                  className="bg-gradient-to-br from-gray-900 to-gray-800 p-6 rounded-2xl border border-orange-500/20 hover:border-orange-500/60 transition-all duration-300 hover:transform hover:scale-105 group">

                  <div className="w-12 h-12 bg-orange-500/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-orange-500/20 transition-colors duration-300">
                    <Icon className="w-6 h-6 text-orange-500" />
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-white">{benefit.title}</h3>
                  <p className="text-gray-400">{benefit.description}</p>
                </div>);

            })}
          </div>
        </div>
      </section>

      {/* For Who Section */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-orange-500/5 to-transparent">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Para Quem é o <span className="text-orange-500">TurboCut?</span>
          </h2>

          <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-2xl border border-amber-500/20">
              <h3 className="text-2xl font-bold mb-6 text-amber-400">Ideal Para:</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  </div>
                  <span className="text-gray-300">Quem quer secar com estratégia</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  </div>
                  <span className="text-gray-300">Quem está em cutting/déficit calórico</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  </div>
                  <span className="text-gray-300">Quem quer mais controle de apetite</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  </div>
                  <span className="text-gray-300">Quem quer energia limpa</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-2xl border border-red-500/20">
              <h3 className="text-2xl font-bold mb-6 text-red-400">Quem Deve Evitar:</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <X className="w-4 h-4 text-red-500" />
                  </div>
                  <span className="text-gray-300">Gestantes e lactantes</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <X className="w-4 h-4 text-red-500" />
                  </div>
                  <span className="text-gray-300">Pessoas sensíveis à cafeína</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <X className="w-4 h-4 text-red-500" />
                  </div>
                  <span className="text-gray-300">Menores de 18 anos</span>
                </li>
              </ul>
              <p className="mt-6 text-sm text-gray-400 italic">
                Em caso de dúvida, consulte um profissional de saúde.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How to Use */}
      <section id="como-usar" className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            Como <span className="text-orange-500">Tomar</span>
          </h2>
          <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
            Modo de uso simples e prático
          </p>

          <div className="max-w-3xl mx-auto space-y-6 mb-12">
            <div className="bg-gradient-to-r from-gray-900 to-gray-800 p-6 rounded-2xl border border-orange-500/20 flex items-start gap-4 hover:border-orange-500/50 transition-all duration-300">
              <div className="w-12 h-12 bg-orange-500/10 rounded-full flex items-center justify-center flex-shrink-0 text-orange-500 font-bold text-xl">
                1
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2 text-white">Sugestão de Uso Diário</h3>
                <p className="text-gray-400">Tome 2 cápsulas ao dia com água. Não exceda a dose recomendada.</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-gray-900 to-gray-800 p-6 rounded-2xl border border-orange-500/20 flex items-start gap-4 hover:border-orange-500/50 transition-all duration-300">
              <div className="w-12 h-12 bg-orange-500/10 rounded-full flex items-center justify-center flex-shrink-0 text-orange-500 font-bold text-xl">
                2
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2 text-white">Melhor Horário</h3>
                <p className="text-gray-400">Preferencialmente pela manhã ou 30 minutos antes do treino para maximizar energia e disposição.</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-gray-900 to-gray-800 p-6 rounded-2xl border border-orange-500/20 flex items-start gap-4 hover:border-orange-500/50 transition-all duration-300">
              <div className="w-12 h-12 bg-orange-500/10 rounded-full flex items-center justify-center flex-shrink-0 text-orange-500 font-bold text-xl">
                3
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2 text-white">Importante</h3>
                <p className="text-gray-400">Evite tomar à noite se você tem sensibilidade à cafeína, para não prejudicar o sono.</p>
              </div>
            </div>
          </div>

          <div className="text-center">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 shadow-xl shadow-green-600/40">

              <Phone className="w-5 h-5" />
              QUERO COMPRAR AGORA
            </a>
          </div>
        </div>
      </section>

      {/* Composition */}
      <section id="composicao" className="py-16 md:py-24 bg-gradient-to-b from-orange-500/5 to-transparent">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            <span className="text-orange-500">Composição</span> Completa
          </h2>
          <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
            Fórmula potente com ingredientes de alta qualidade
          </p>

          <div className="max-w-4xl mx-auto bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl border border-amber-500/30 overflow-hidden shadow-2xl">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-orange-500/20 to-amber-500/20 border-b border-amber-500/30">
                    <th className="px-6 py-4 text-left text-amber-400 font-bold">Ingrediente</th>
                    <th className="px-6 py-4 text-left text-amber-400 font-bold">Função</th>
                  </tr>
                </thead>
                <tbody>
                  {composition.map((item, index) =>
                  <tr
                    key={index}
                    className={`border-b border-gray-700 hover:bg-orange-500/5 transition-colors duration-300 ${
                    index % 2 === 0 ? 'bg-gray-900/50' : ''}`
                    }>

                      <td className="px-6 py-4 font-semibold text-white">{item.name}</td>
                      <td className="px-6 py-4 text-gray-400">{item.description}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-gradient-to-br from-orange-500/10 via-amber-500/10 to-orange-500/10 p-8 md:p-12 rounded-3xl border border-amber-500/30 shadow-2xl">
            <div className="text-center mb-8">
              <div className="inline-block px-6 py-2 bg-amber-500/20 border border-amber-500/50 rounded-full mb-4">
                <span className="text-amber-400 font-bold">DESTAQUES</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white">
                Por Que Escolher o <span className="text-orange-500">TurboCut?</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-3 h-3 bg-amber-400 rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h3 className="font-bold text-lg text-white mb-1">Cápsulas Fáceis de Tomar</h3>
                  <p className="text-gray-400">Praticidade no seu dia a dia</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-3 h-3 bg-amber-400 rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h3 className="font-bold text-lg text-white mb-1">Fórmula Inteligente</h3>
                  <p className="text-gray-400">Ingredientes cientificamente estudados</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-3 h-3 bg-amber-400 rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h3 className="font-bold text-lg text-white mb-1">Alta Concentração</h3>
                  <p className="text-gray-400">Máxima potência em cada dose</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-3 h-3 bg-amber-400 rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h3 className="font-bold text-lg text-white mb-1">Rotina Corrida</h3>
                  <p className="text-gray-400">Perfeito para quem tem dia agitado</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-16 md:py-24 bg-gradient-to-b from-transparent to-orange-500/5">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            Perguntas <span className="text-orange-500">Frequentes</span>
          </h2>
          <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
            Tire suas dúvidas sobre o TurboCut
          </p>

          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) =>
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-gradient-to-br from-gray-900 to-gray-800 border border-orange-500/20 rounded-xl px-6 hover:border-orange-500/50 transition-all duration-300">

                  <AccordionTrigger className="text-left font-semibold text-white hover:text-orange-500 py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-400 pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              )}
            </Accordion>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 md:py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-orange-500/10 via-orange-500/5 to-transparent"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="mb-8">
              <Flame className="w-16 h-16 text-orange-500 mx-auto mb-6" />
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                Pronto(a) para dar o próximo passo no seu <span className="text-orange-500">cutting?</span>
              </h2>
              <p className="text-xl text-gray-400 mb-8">
                Entre em contato agora e descubra como o TurboCut pode transformar seus resultados
              </p>
            </div>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-12 py-6 rounded-full font-bold text-xl transition-all duration-300 hover:scale-105 shadow-2xl shadow-green-600/50">

              <Phone className="w-6 h-6" />
              COMPRAR TURBOCUT NO WHATSAPP
            </a>

            <p className="mt-8 text-sm text-gray-500">
              Atendimento rápido • Formas de pagamento flexíveis
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-b from-gray-900 to-black border-t border-gray-800 py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <Flame className="w-8 h-8 text-orange-500" />
                <span className="text-2xl font-bold">
                  <span className="text-white">Turbo</span>
                  <span className="text-orange-500">Cut</span>
                </span>
              </div>
              <p className="text-gray-400 text-sm">
                Emagrecedor Extra Forte para quem busca resultados reais.
              </p>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-lg font-bold mb-4 text-white">Contato</h3>
              <div className="space-y-3">
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-400 hover:text-green-500 transition-colors duration-300">

                  <Phone className="w-5 h-5" />
                  <span>+55 21 97223-2170</span>
                </a>
                <a
                  href="https://instagram.com/turbocut"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-400 hover:text-orange-500 transition-colors duration-300">

                  <Instagram className="w-5 h-5" />
                  <span>@turbocut</span>
                </a>
                <a
                  href="mailto:contato@turbocut.com"
                  className="flex items-center gap-2 text-gray-400 hover:text-orange-500 transition-colors duration-300">

                  <Mail className="w-5 h-5" />
                  <span>contato@turbocut.com.br</span>
                </a>
              </div>
            </div>

            {/* Legal */}
            <div>
              <h3 className="text-lg font-bold mb-4 text-white">Informações</h3>
              <div className="space-y-2">
                <button className="block text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm">
                  Política de Privacidade
                </button>
                <button className="block text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm">
                  Termos de Uso
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8">
            <p className="text-center text-gray-500 text-sm">
              © {new Date().getFullYear()} TurboCut. Todos os direitos reservados.
            </p>
            <p className="text-center text-gray-600 text-xs mt-2">
              Este produto não se destina a diagnosticar, tratar, curar ou prevenir qualquer doença. Resultados podem variar de pessoa para pessoa.
            </p>
          </div>
        </div>
      </footer>
    </div>);

};

export default TurboCut;